import React, { useState, useEffect } from 'react';
import NewTodo from './components/check';
import styles from "./styles/newtodo.module.css";
import ManageProjects from './components/manageprojects';
import { Tab, TabList, TabPanel, Tabs } from '@mui/joy';
import TodoTable from './components/table';
import useTodoProjects from './useTodoProjects';
import RegularTodos from './components/regulartodos';
import ManagePhoneMain from '../managephone/managephonemain';
import CctvMain from '../../cctv/cctvmain';
import RegularKakao from './components/regularkakao';
import CleanTable from './components/cleantable';
import WinterRegisterMain from './components/winterregistermain';
import EducationVideoIpManager from './components/educationvideoipmanager';
import BranchRecruitStatus from './components/branchrecruitstatus';
import NaverReviewWriter from './components/naverreviewwriter';
import BiostarEnrollDeviceSetting from './components/biostarenrolldevicesetting';
import WiredPhoneSetting from './components/wiredphonesetting';
import MealPlanImage from './components/mealplanimage/mealplanimage';
import FaqAdminMain from '../../faq/admin/faqadminmain';


const NewTodoMain: React.FC<any> = (props: any) => {

    const [menu, setMenu] = useState<any>(0);

    //프로젝트 로드/갱신 로직은 홈 화면 TODO 탭과 공용 훅으로 공유
    const { projects, loading, letsUpdate, moveTaskToTop, addNoteToTask, markNotesRead } = useTodoProjects({
        user: props.user,
        category: "headquarters",
        externalUpdate: props.newTodoistDataUpdate
    });

    useEffect(() => {

        props.activateMenuList("circle-check");

    }, []);



    return (
        <div className={styles.main}>

            {/* 소메뉴가 많아 줄바꿈되지 않도록 한 줄 가로 스크롤 (Joy 스크롤 탭 패턴: TabList overflow + Tab flex none) */}
            <Tabs aria-label="Basic tabs" defaultValue={0} sx={{
                width: "96%",
                backgroundColor: "transparent"
            }}
                onChange={(e: any, value: any) =>
                    setMenu(value)
                }
            >
                <TabList
                    sx={{
                        overflowX: "auto",
                        overflowY: "hidden",
                        flexWrap: "nowrap",
                        scrollSnapType: "x mandatory",
                        "&::-webkit-scrollbar": { height: "6px" },
                        "&::-webkit-scrollbar-thumb": { backgroundColor: "#d0d0d0", borderRadius: "3px" },
                        "& .MuiTab-root": { flex: "none", whiteSpace: "nowrap", scrollSnapAlign: "start" }
                    }}
                >
                    <Tab>TODO 테이블</Tab>
                    <Tab>핸드폰 관리</Tab>
                    <Tab>각 지점별 모집상태</Tab>
                    <Tab>CCTV</Tab>
                    <Tab>반복 TODO 등록</Tab>
                    <Tab>반복 카톡 메시지 등록</Tab>
                    <Tab>윈터 스쿨 등록 관리</Tab>
                    <Tab>교육영상 IP 관리</Tab>
                    <Tab>프로젝트/섹션 관리</Tab>
                    <Tab>페이지 보기</Tab>
                    <Tab>네이버 리뷰 작성자</Tab>
                    <Tab>지점별 인증 등록장치 설정</Tab>
                    <Tab>유선 전화기 등록</Tab>
                    <Tab>식단표 이미지 만들기</Tab>
                    <Tab>FAQ 관리</Tab>
                </TabList>
            </Tabs>






            {
                menu === 0 ?
                    <TodoTable projects={projects}
                        loading={loading}
                        apiKey={props.user ? "todo" : ""}
                        letsUpdate={letsUpdate}
                        moveTaskToTop={moveTaskToTop}
                        userName={props.user ? props.user.name : ""}
                        addNoteToTask={addNoteToTask}
                        markNotesRead={markNotesRead}
                        user={props.user}
                    />
                    :
                    ""
            }


            {
                menu === 1 ?
                    <ManagePhoneMain
                        forAdmin={true}
                        user={props.user}
                        socket={props.socket}
                    />
                    :
                    ""
            }

            {
                menu === 2 ?
                    <BranchRecruitStatus
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 3 ?
                    <CctvMain
                        user={props.user}
                        socket={props.socket}
                    />
                    :
                    ""
            }

            {
                menu === 4 ?
                    <RegularTodos
                        projects={projects}
                        apiKey={props.user ? "todo" : ""}
                        letsUpdate={letsUpdate}
                    />
                    :
                    ""
            }

            {
                menu === 5 ?
                    <RegularKakao
                        user={props.user}
                        socket={props.socket}
                    />
                    :
                    ""
            }

            {
                menu === 6 ?
                    <WinterRegisterMain
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 7 ?
                    <EducationVideoIpManager
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 8 ?
                    <ManageProjects
                        projects={projects}
                        letsUpdate={letsUpdate}
                        category="headquarters"
                    />
                    :
                    ""
            }

            {
                menu === 10 ?
                    <NaverReviewWriter
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 11 ?
                    <BiostarEnrollDeviceSetting
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 12 ?
                    <WiredPhoneSetting
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 13 ?
                    <MealPlanImage
                        user={props.user}
                    />
                    :
                    ""
            }

            {
                menu === 14 ?
                    <FaqAdminMain
                        user={props.user}
                    />
                    :
                    ""
            }

        </div>
    )
}

export default NewTodoMain;